var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "booking-confirmation" }, [
    _c("div", { staticClass: "success-card" }, [
      _c("div", { staticClass: "success-icon" }, [_vm._v("✓")]),
      _vm._v(" "),
      _c("h2", { staticClass: "success-title" }, [
        _vm._v(_vm._s(_vm.$t("bookingConfirmed")))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "success-sub" }, [
        _vm._v(
          _vm._s(
            _vm.detailsCompleted
              ? _vm.$t("bookingDone")
              : _vm.$t("bookingStage1Done")
          )
        )
      ])
    ]),
    _vm._v(" "),
    !_vm.detailsCompleted
      ? _c("section", { staticClass: "confirm-section reminder-section" }, [
          _c("div", { staticClass: "section-heading" }, [
            _vm._v(_vm._s(_vm.$t("completeDetailsTitle")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "section-body" }, [
            _c("p", { staticClass: "reminder-copy" }, [
              _vm._v(_vm._s(_vm.$t("completeDetailsHint")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-complete",
                attrs: { type: "button" },
                on: { click: _vm.goToDetails }
              },
              [_vm._v(_vm._s(_vm.$t("completeDetails")))]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("section", { staticClass: "confirm-section" }, [
      _c("div", { staticClass: "section-heading" }, [
        _vm._v(_vm._s(_vm.$t("bookingDetails")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-body" }, [
        _vm.data.email
          ? _c("div", { staticClass: "detail-row" }, [
              _c("span", { staticClass: "detail-label" }, [_vm._v("Email")]),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.data.email))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.facilityName
          ? _c("div", { staticClass: "detail-block" }, [
              _c("span", { staticClass: "detail-label" }, [
                _vm._v(_vm._s(_vm.$t("store")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-value-block" }, [
                _c("div", { staticClass: "facility-name" }, [
                  _vm._v(_vm._s(_vm.facilityName))
                ]),
                _vm._v(" "),
                _vm.facilityAddress
                  ? _c("div", { staticClass: "facility-address" }, [
                      _vm._v(_vm._s(_vm.facilityAddress))
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.data.local_drop_off_date
          ? _c("div", { staticClass: "detail-row" }, [
              _c("span", { staticClass: "detail-label" }, [_vm._v("Drop-off")]),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.data.local_drop_off_date))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.data.local_pick_up_date
          ? _c("div", { staticClass: "detail-row" }, [
              _c("span", { staticClass: "detail-label" }, [_vm._v("Pick-up")]),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.data.local_pick_up_date))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.passengerName
          ? _c("div", { staticClass: "detail-row" }, [
              _c("span", { staticClass: "detail-label" }, [
                _vm._v("Passenger")
              ]),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.passengerName))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.luggageSummary
          ? _c("div", { staticClass: "detail-row" }, [
              _c("span", { staticClass: "detail-label" }, [_vm._v("Luggage")]),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v(_vm._s(_vm.luggageSummary))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.estimatedTotal != null
          ? _c("div", { staticClass: "detail-row total" }, [
              _c("span", { staticClass: "detail-label" }, [
                _vm._v("Estimated Total")
              ]),
              _c("span", { staticClass: "detail-value" }, [
                _vm._v("$" + _vm._s(Number(_vm.estimatedTotal).toFixed(2)))
              ])
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "confirm-section" }, [
      _c("div", { staticClass: "section-heading" }, [
        _vm._v(_vm._s(_vm.$t("qrTitle")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "section-body qr-body" }, [
        _c("div", { staticClass: "qr-placeholder" }, [
          _c("div", { staticClass: "qr-box" }, [
            _vm.qrDataUrl
              ? _c("img", {
                  staticClass: "qr-image",
                  attrs: { src: _vm.qrDataUrl, alt: "Booking QR" }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "qr-hint" }, [
            _vm._v(_vm._s(_vm.$t("showAtCounter")))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "actions" }, [
      !_vm.detailsCompleted
        ? _c(
            "button",
            {
              staticClass: "btn-complete secondary",
              attrs: { type: "button" },
              on: { click: _vm.goToDetails }
            },
            [_vm._v(_vm._s(_vm.$t("completeDetails")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-new",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$router.push("/")
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("createNewBooking")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc0b8ba4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc0b8ba4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookingConfirmation.vue
// module id = 464
// module chunks = 0